import { render, staticRenderFns } from "./DrawerAiCallForm.vue?vue&type=template&id=b5492e52&scoped=true"
import script from "./DrawerAiCallForm.vue?vue&type=script&lang=js"
export * from "./DrawerAiCallForm.vue?vue&type=script&lang=js"
import style0 from "./DrawerAiCallForm.vue?vue&type=style&index=0&id=b5492e52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5492e52",
  null
  
)

export default component.exports